import { actions, types } from './requests'
export const GETCONTRACTLIST_TYPES = {
    ...types('GETCONTRACTLIST'),
}
export const GETCONTRACTLIST_ACTIONS = {
    ...actions('GETCONTRACTLIST'),
}
